import type { InternalAxiosRequestConfig } from "axios";

import { authStore } from "@/shared/stores";

export const privateRequest = (config: InternalAxiosRequestConfig) => {
  const token = authStore.getToken();

  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  return config;
};
